// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YrQj","fullView":"styles_fullView__26tuW"};